import React from "react";
import "./styles.scss";

const JioGlassPrivacyPolicy = () => {
  return (
    <>
      <div className="privacy-policy-jioglass">
        <h1 className="privacy-policy-jioglass-heading">
          JioImmerse App Privacy Policy
        </h1>
        <strong>
          Thank you for using JioImmerse! Your privacy is important to us. To
          better protect your privacy, and to help ensure a rewarding experience
          for all users, we provide this privacy policy.{" "}
        </strong>
        <h3 role="presentation">
          <strong>1. Scope</strong>
        </h3>
        <span className="ul-text">
          JioImmerse (hereinafter referred to as “App”, “we”, “our”, “us”) is
          committed to protecting and respecting your privacy.
        </span>

        <ul className="ul_style">
          <li role="presentation">1.1&nbsp;</li>
          <li className="li_style" role="presentation">
            This policy (this “Privacy Policy”), together with the Terms and
            Conditions of the App outlines the App’s privacy practices regarding
            the collection, use and safeguard of your information through the
            App and the services offered thereupon.
          </li>
        </ul>
        <ul className="ul_style">
          <li role="presentation">1.2&nbsp;</li>
          <li className="li_style" role="presentation">
            By using the App or registering or signing up for the App and
            submission of personal information; or if you are a minor, the
            submission of your personal information either by your parents (or
            your guardian) or by you with the permission of your parents (or
            guardian) to the App will be deemed as your acceptance of this
            Privacy Policy.
          </li>
        </ul>
        <ul className="ul_style">
          <li role="presentation">1.3&nbsp;</li>
          <li className="li_style" role="presentation">
            The Terms are an electronic record in terms of the Information
            Technology Act, 2000 (as amended / re-enacted) (“IT Act") and rules
            thereunder, and is published in accordance with the provisions of
            Rule 3 (1) (a) of Information Technology (Intermediary Guidelines
            and Digital Media Ethics code) Rules, 2021, which mandates for
            publishing of rules and regulations, privacy policy and terms of use
            for access or usage of Application. This electronic record is
            generated by a computer system and does not require any physical or
            digital signatures.
          </li>
        </ul>
        <h3 role="presentation">
          <strong>2. Changes to the Privacy Policy</strong>
        </h3>
        <ul className="ul_style">
          <li role="presentation">2.1&nbsp;</li>
          <li className="li_style" role="presentation">
            We are obligated to protect your information in accordance with
            applicable laws, and regulations.
          </li>
        </ul>
        <ul className="ul_style">
          <li role="presentation">2.2&nbsp;</li>
          <li className="li_style" role="presentation">
            This Privacy Policy is subject to modification based on changes in
            the business, legal and regulatory requirements and will be updated
            online. We will notify you whenever any change to the Privacy Policy
            are made. You are encouraged to periodically visit this page to
            review the Privacy Policy and any changes to it.
          </li>
        </ul>
        <h3 role="presentation">
          <strong>3. Third Party Services </strong>
        </h3>
        <ul className="ul_style">
          <li role="presentation">3.1&nbsp;</li>
          <li className="li_style" role="presentation">
            Please note that your mobile service provider, mobile operating
            system provider, third party applications including the applications
            pre-loaded on your smart phones powered by Android platform or
            customized Android ROM (“Device”), social media platforms and
            websites that you access, third party operators may also collect,
            use and share information about you and your usage. We cannot
            control how these third parties collect, use, share or secure this
            information. For information about third-party privacy practices,
            please consult their respective privacy policies.
          </li>
        </ul>
        <h3 role="presentation">
          <strong>4. Personal Information We Collect </strong>
        </h3>
        <ul className="ul_style">
          <li role="presentation">4.1&nbsp;</li>
          <li className="li_style" role="presentation">
            Personal information is defined as information that can be used to
            identify you and may include details such as your name, age, gender,
            contact information, products and services you are interested in or
            require more information about. Insofar as sensitive personal
            information is concerned, it will carry the meaning as may be
            defined by applicable laws from time to time.
          </li>
        </ul>
        <ul className="ul_style">
          <li role="presentation">4.2&nbsp;</li>
          <li className="li_style" role="presentation">
            The following is the manner in which we collect, use, share and
            retain personal information:
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.1</li>
          <li className="li_style sub-points" role="presentation">
            &nbsp;Collection
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.1.1&nbsp;</li>
          <li className="li_style" role="presentation">
            You agree that the App may collect such personal information,
            whenever relevant, to help providing you with information and to
            complete any transaction or provide any product you have requested
            or authorized. You also consent to the collection of certain
            personal information in the course of your applying for the products
            and/or services.
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.2</li>
          <li className="li_style sub-points" role="presentation">
            &nbsp;Usage
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.2.1&nbsp;</li>
          <li className="li_style" role="presentation">
            The App seeks this information either to (i) validate and process
            your request for the services of the App or information; (ii) to
            improve the quality of the App; (iii) to assist you to determine
            which services best meet your needs; or (iv) to facilitate our
            internal business operations, including the fulfilment of any legal
            and regulatory requirements; or (v) to provide you with
            recommendation about services you may be interested in, based on
            your use of the App; or (vi) to provide you with marketing
            communications and advertising that the App believe may be of
            interest of you ;or (vii) to facilitate your purchases .
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.3</li>
          <li className="li_style sub-points" role="presentation">
            &nbsp;Sharing
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.3.1&nbsp;</li>
          <li className="li_style" role="presentation">
            We may disclose personal information to our affiliates when
            necessary to perform services on our behalf or on your behalf, to
            provide display advertising and promotional services, providing
            search results and links (including paid listings and links),
            processing credit card payments, providing customer service, improve
            our services and analytics, provide the products/services, testing
            or improvement of services, recommending various products or
            services etc.
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.3.2&nbsp;</li>
          <li className="li_style" role="presentation">
            We may also share personal information with external organizations
            or individuals if we believe that access, use, preservation or
            disclosure of the information is reasonably necessary to: (a) meet
            any applicable law, regulation, legal process or enforceable
            governmental request; (b) detect, prevent or otherwise address
            fraud, security or technical issues; (c) protect against harm to the
            rights, property or safety of our customers or the public, as
            required or permitted by law.  
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.4</li>
          <li className="li_style sub-points" role="presentation">
            &nbsp;Retention
          </li>
        </ul>
        <ul className="ul_style">
          <li>4.2.4.1&nbsp;</li>
          <li className="li_style" role="presentation">
            The information so collected shall be retained only for a limited
            duration necessary to fulfil the purposes outlined herein unless a
            longer retention period is required or permitted by law and only for
            the purposes defined above. Once the purpose is achieved, all
            personal information is deleted in a safe and secure mode.
          </li>
        </ul>
        <h3 role="presentation">
          <strong>5. Non-Personal Information </strong>
        </h3>
        <ul className="ul_style">
          <li>5.1&nbsp;</li>
          <li className="li_style" role="presentation">
            Non-personal information is defined as any data that does not
            personally identify you and may include unique system or hardware
            identifiers, system or application software, and peripherals.
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.2&nbsp;</li>
          <li className="li_style" role="presentation">
            Any non-personal information, when clubbed with personal information
            shall be treated as personal information.
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3&nbsp;</li>
          <li className="li_style" role="presentation">
            The following is the manner in which we collect, use, share and
            retain non-personal information.
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.1</li>
          <li className="li_style sub-points" role="presentation">
            &nbsp;Collection
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.1.1&nbsp;</li>
          <li className="li_style" role="presentation">
            You agree that the App may collect diagnostic, technical, usage
            related information, for the usage purposes described below.
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.2</li>
          <li className="li_style sub-points" role="presentation">
            &nbsp;Usage
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.2.1&nbsp;</li>
          <li className="li_style" role="presentation">
            The above mentioned information is gathered periodically to provide
            and improve the App and services therein, facilitate the provision
            of software updates, product support and other services to you (if
            any) and to verify compliance with the terms of this Policy.  
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.3</li>
          <li className="li_style sub-points" role="presentation">
            &nbsp;Sharing
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.3.1&nbsp;</li>
          <li className="li_style" role="presentation">
            To enable the App partners and third party developers to improve
            their software, hardware and services designed for use with the App,
            we may also provide any such partner or third party developer with a
            subset of diagnostic information that is relevant to that partner’s
            or developer’s software, hardware and/or services, as long as the
            diagnostic information is in a form that does not personally
            identify you.  
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.4</li>
          <li className="li_style sub-points" role="presentation">
            &nbsp;Retention
          </li>
        </ul>
        <ul className="ul_style">
          <li>5.3.4.1&nbsp;</li>
          <li className="li_style" role="presentation">
            The information so collected shall be retained only for a limited
            duration necessary to fulfil the purposes outlined herein unless a
            longer retention period is required or permitted by law and only for
            the purposes defined above. Once the purpose is achieved, all
            information is deleted in a safe and secure mode.
          </li>
        </ul>
        <h3 role="presentation">
          <strong>6. Location Services </strong>
        </h3>
        <ul className="ul_style">
          <li>6.1&nbsp;</li>
          <li className="li_style" role="presentation">
            The App, its licensees and agents, may access, collect and analyse
            your usage of the App and other information related to your location
            on a regular basis through Bluetooth and Wi-Fi signals and other
            technologies and data for the performance of the services provided
            by the App and to help improve the design, functionality,
            performance, and content of the App. In order to collect
            geo-location information, the location settings must be enabled on
            your device. Therefore, in some cases, the App may request that you
            enable the location settings.
          </li>
        </ul>
        <ul className="ul_style">
          <li>6.2&nbsp;</li>
          <li className="li_style" role="presentation">
            Except in cases where any specific services requested by you require
            or involve personal identification, the App collects location data
            anonymously and in a form that does not personally identify you. By
            using the App, you agree and consent to transmission, collection,
            maintenance, processing and use of your location data and queries to
            provide and improve such services of the App.
          </li>
        </ul>
        <h3 role="presentation">
          <strong>7. Cookies </strong>
        </h3>
        <ul className="ul_style">
          <li>7.1&nbsp;</li>
          <li className="li_style" role="presentation">
            Information collected by cookies and other technologies are treated
            as nonpersonal information. However, to the extent that IP addresses
            or similar identifiers are considered personal information by local
            law, we treat any information linked to such identifiers as personal
            information. Similarly, to the extent that non-personal information
            is combined with personal information, we will treat the combined
            information as personal information.
          </li>
        </ul>
        <h3 role="presentation">
          <strong>8. Other Information the App Collects </strong>
        </h3>
        <ul className="ul_style">
          <li>8.1&nbsp;</li>
          <li className="li_style" role="presentation">
            The App also may collect other information about you in ways that
            the App describe to you or otherwise with your consent. You can
            choose not to provide us with certain types of information, but
            doing so may affect your ability to avail and/or use some services.
          </li>
        </ul>
        <ul className="ul_style">
          <li>8.2&nbsp;</li>
          <li className="li_style" role="presentation">
            By clicking “I Accept” button or by usage of the App you permit to
            enable certain functions of the device to find the location of your
            device, modify or delete SD card contents, read phone statistics and
            identity, mount and unmount file systems, contacts saved in your
            device, conferencing logs and history etc.
          </li>
        </ul>
        <ul className="ul_style">
          <li>8.3&nbsp;</li>
          <li className="li_style" role="presentation">
            The features of the App may allow you to post content such as
            profile information, status update, comments, and other content
            and/or information (User Content). The ownership over the User
            Content created by you remains with you; however, by sharing User
            Content through the App, you agree to allow others to view and/or
            share your User Content in accordance with this Privacy Policy.
          </li>
        </ul>
        <h3 role="presentation">
          <strong>9. Third Party Applications, Websites & Services </strong>
        </h3>
        <ul className="ul_style">
          <li>9.1&nbsp;</li>
          <li className="li_style" role="presentation">
            The App may include links to other websites/applications or may
            display advertisements from third parties and other content that
            links to third party websites. Such websites/applications are
            governed by their respective privacy policies, which are out of the
            App’s control. Use of any information you provide while using a
            third party website or application through the App, is governed by
            the privacy policy of the operator of the website / application /
            operator you are using/ visiting. That policy may differ from that
            of the App. If you can't find the privacy policy of any of such
            websites /application via a link from the website's homepage, you
            should contact the relevant website /application operator directly
            for more information.
          </li>
        </ul>
        <h3 role="presentation">
          <strong>10. Access, Correction and Deletion </strong>
        </h3>
        <ul className="ul_style">
          <li>10.1&nbsp;</li>
          <li className="li_style" role="presentation">
            The App strives hard to keep its records updated and accurate with
            your latest information. You shall be responsible to ensure that the
            information or data you provide from time to time is and shall be
            correct, current and updated and you have all the rights,
            permissions and consents to provide such information or data.
          </li>
        </ul>
        <ul className="ul_style">
          <li>10.2&nbsp;</li>
          <li className="li_style" role="presentation">
            You may note that deletion of certain information or withdrawal of
            consent may lead to cancellation of your access to the App or your
            access to certain features and services of the App. Additionally, we
            may not be able to process your request of correction, updating or
            deletion, in case the same is not supported by valid documents or
            data retention is required by the applicable law or law enforcement
            requests or under any judicial proceedings or it is extremely
            difficult to implement (such as requests related to backup copies or
            if a new system is required to process the request or change of
            technical design) or risks the privacy of other users.
          </li>
        </ul>
        <ul className="ul_style">
          <li>10.3&nbsp;</li>
          <li className="li_style" role="presentation">
            You acknowledge and agree that you may receive certain notifications
            relating to the App on your Device or on registered contact detail.
            At any given point of time, if you decide to not receive
            notification, you may turn off such notifications through the App by
            going to the ‘App settings’ page of the App.
          </li>
        </ul>
        <ul className="ul_style">
          <li>10.4&nbsp;</li>
          <li className="li_style" role="presentation">
            You may request access, correction or updating, and deletion of the
            information provided by contacting us at grievance.officer@jio.com.
          </li>
        </ul>
        <h3 role="presentation">
          <strong>11. Queries and Complaints </strong>
        </h3>
        <ul className="ul_style">
          <li>11.1&nbsp;</li>
          <li className="li_style" role="presentation">
            We are committed to protect your personal information collected and
            processed by us and look forward to your continued support for the
            same. In case of any feedback or concern regarding protection of
            your personal information, or any privacy-related feedback or
            concerns you may contact: Mrs. Radha Nair, Reliance Corporate IT
            Park, TC-22, Thane Belapur Road, Ghansoli, Navi Mumbai 400701 Email
            id: grievance.officer@jio.com
          </li>
        </ul>
      </div>
    </>
  );
};

export default JioGlassPrivacyPolicy;
